import React, { useEffect } from "react";
import { AlarmIcon } from "../utils/Icons";
import { showInfo } from "../utils/Utils";
import dayjs from "dayjs";
import dayjs_plugin_duration from 'dayjs/plugin/duration';
import Divider from "../ui/Divider";
export default function ScheduleChecker() {

    dayjs.extend(dayjs_plugin_duration);


    // need to get actual time - currently using system time...
    const current_time = dayjs();


    const warning_message = <>

        <p style={{ "textAlign": "left" }}>
            While we ingest new backups, this app will be put into "Maintenance Mode". <strong>This down-time can last up to 45 minutes, at which time you will be unable to access any functions of BMO.</strong>
            <br /><br />
            If you need to use BMO during this time, we highly recommend that you go to the <strong>Scheduler</strong> on any station, type <kbd className="light">W</kbd> for workstation to isolate the station running your backup routine(s), and toggle the upcoming <strong>Backup Bookmanager</strong> routine(s) to <strong>Off</strong>. Make sure to <strong>set yourself a reminder to turn the routine(s) back on</strong> after you are done with BMO.
        </p>
    </>

    function getNextTime(_schedule, _time = current_time) {
        let shortest = false;
        let next = null;
        let station = "";
        let id = "";

        _schedule.forEach(item => {


            let target = convertToTime(item.time);


            if (target.isBefore(_time)) {
                target = target.add(1, "day");
            }

            const diff = target.diff(_time);

            if (!shortest || diff < shortest) {
                shortest = diff;
                next = target;
                station = item.station;
                id = item?.id;
            }
        });

        const duration = dayjs.duration(shortest);

        return {
            next: (next) ? next.format("h:mma") : "none",
            hours: duration.hours(),
            minutes: duration.minutes(),
            station: station,
            id: id,

        };
    }

    const convertToTime = (_str_time, _time = current_time) => {
        const [h, m] = _str_time.split(":").map(Number);
        return dayjs().hour(h).minute(m).second(0).millisecond(0);
    }


    const check = () => {
        const nextBackup = getNextTime(window?.settings?.backup_schedules);

        if(nextBackup?.next === "none"){
            return; 
        }
        // check is within 30m
        if (nextBackup?.hours === 0 && nextBackup?.minutes < 30) {
            // check if already run
            if (!window?.[nextBackup?.id]) {
                showWarning()
                window[nextBackup?.id] = true;
            }
        }
    }

    useEffect(() => {



        const intervalId = setInterval(() => {
            check();
        }, 10000); // Update every second



        return () => clearInterval(intervalId); // Cleanup on unmount
    }, []);


    const showWarning = () => {


        const nextBackup = getNextTime(window?.settings?.backup_schedules, dayjs());

        showInfo({
            controller: "home",
            type: "error",
            route: window.bm_state.value,
            description: <div style={{ "textAlign": "center", "width": "500px", "minWidth": "200px", "lineHeight": "18px" }}>
                <p>Scheduled Bookmanager software backup set to run at:  <strong style={{ "textDecoration": "underline" }}>{nextBackup.next}</strong> on station <strong style={{ "textDecoration": "underline" }}>{nextBackup.station}</strong></p>
                <div className="shim" />
                <strong><big><big>
                    {(nextBackup.hours > 0 && <>{nextBackup.hours} hours and </>)}
                    {nextBackup.minutes} minutes.</big></big></strong>

                <div className="shim" /><div className="shim" />

                {warning_message}
            </div>,
            title: "Warning!",
            callback: (e) => {
                if (!e) {

                }
            }
        })

    }


    const showSchedule = () => {

        showInfo({
            controller: "home",
            type: "error",
            route: window.bm_state.value,
            description: <div style={{ "textAlign": "left", "width": "450px", "minWidth": "200px" }}>
                <p>You have scheduled Bookmanager software backups set to run on the following stations and times:</p>
                <div className="shim" /><div className="shim" />
                <div style={{ "display": "flex", "flexDirection": "column", "textAlign": "left", "padding": "10px", "border": "1px solid #ffffff44" }}>
                    <div style={{ "borderBottom": '1px dashed #ffffff44' }} key={"header"} className="row">
                        <div style={{ "flex": "2 1 0", "padding": "4px 8px" }}><strong>Task</strong></div>
                        <div style={{ "padding": "4px 8px", "width": "60px" }}><strong>Station</strong></div>
                        <div style={{ "padding": "4px 8px", "width": "60px" }}><strong>Time</strong></div>
                    </div>
                    <div className="shim" />
                    {window?.settings?.backup_schedules.map((row, i) => (
                        <div key={i} className="row">
                            <div style={{ "flex": "2 1 0", "padding": "4px 8px" }}>{row.task}</div>
                            <div style={{ "padding": "4px 8px", "width": "60px" }}>{row.station}</div>
                            <div style={{ "padding": "4px 8px", "width": "60px" }}>{convertToTime(row.time).format("h:mma")}</div>
                        </div>
                    ))}

                </div>
                <div className="shim" /><div className="shim" />
                {warning_message}
            </div>,
            title: "Scheduled Backups",
            callback: (e) => {
                if (!e) {

                }
            }
        })
    }

    return (<a onClick={() => showSchedule()} style={{ "color": "var(--text-red)" }}><AlarmIcon /></a>)

}